import React, { Component } from "react"
import PropTypes from "prop-types"
import { connect } from "react-redux"
import MetaTags from 'react-meta-tags';
import { Accordion, AccordionBody, AccordionHeader, AccordionItem, CardBody, CardHeader, Container } from "reactstrap"
import { withRouter } from "react-router-dom"
import { isEmpty, map } from "lodash"
import Board from 'react-trello'
//Import Breadcrumb
import Breadcrumbs from "components/Common/Breadcrumb"
import { Link } from "react-router-dom"
import { getContacts, updateClassificationBoard } from "../../../store/actions"
import FilterMenuContact from "../filter-menu/filter-menu"
import RsAdNew from "components/buttons/Adnew";
import styled from 'styled-components';
import {
  Row,
  Col,
  Card, Offcanvas, OffcanvasHeader, OffcanvasBody,
} from "reactstrap";
import "assets/scss/tasks.scss"
import CreateContact from "../forms/contact-create"
import { withTranslation } from "react-i18next"
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import dragImg from "../../../assets/img/drag-and-drop.png"
const laneColors = ['#FF9999', '#99FF99', '#9999FF', '#FFFF99', '#FF99FF', '#99FFFF'];
const StyledBoard = styled(Board)`
  padding: 20px;
  
  .react-trello-lane:nth-child(1) header{
    //background-color: #0D6EFD;
    border-bottom:3px solid #0D6EFD !important;
    border:1px solid #ccc;
    //text-align:left;
    color:#000;
  }
  .react-trello-lane:nth-child(2) header{
    //background-color: rgb(255, 222, 89);
     border-bottom:3px solid #198754 !important;
      border:1px solid #ccc;
    //text-align:center;
    color:#000;
  }
   .react-trello-lane:nth-child(3) header{
    //background-color: rgb(92, 225, 230);
    border-bottom:3px solid #0DCAF0 !important;
    border:1px solid #ccc;
    //text-align:center;
    color:#000;
  }
  .react-trello-lane:nth-child(4) header{
    //background-color: rgb(126, 217, 87);
    border-bottom:3px solid #AB2E3C !important;
    border:1px solid #ccc;
    //text-align:center;
    color:#000;
  }
  .react-trello-lane:nth-child(5) header{
    //background-color: rgb(255, 189, 89);
   border-bottom:3px solid #FFC107 !important;
   border:1px solid #ccc;
    //text-align:center;
    color:#000;
  }

  .react-trello-lane header{
    //background-color: rgb(0, 0, 0);
    //text-align:center;
    border-bottom:3px solid #000 !important;
    border:1px solid #ccc;
    color:#000;
    padding: 10px 1.25rem !important;
    background-color:#fff;
  }
  .react-trello-lane{ background-color:#f8f8f8 !important; padding: 10px 5px !important; padding-top:0px !important; }
  .CIzYb{ font-size:16px; padding-left: 1.25rem; text-transform: uppercase;}
`;
const CustomCard = ({ onClick, title, description, metadata  }) => {
 
  return (
    <Card className="mb-3 custom-card" onClick={onClick}>
      <CardBody>
      <div className="float-end ms-2"><span className="badge rounded-pill badge-soft-success font-size-12"></span></div>
      <div className="d-flex align-items-center">
        <h5 className="card-title mb-2 lead-box-title w-100"><Link to="#">{title}</Link> <Link className="float-end" to={`/contact/contact-detail/`+metadata.id+"/"+metadata.link}><i className=" bx bx-link-external font-size-20"></i></Link></h5>
      </div>
      <div><i className="bx bx-phone align-middle"></i>: {metadata.mobile}</div>
      <div>  <i className=" bx bxs-envelope align-middle"></i>: {metadata.email}</div>
      {/* <div><i className=" bx bxs-timer align-middle"></i>: </div>
      <div> <i className=" bx  bxs-calendar align-middle"></i>: </div> */}
      <div className="row pt-1">
   
        {/* <div className="col-4"><Link className="line-79" to={`/lead/lead-detail/`+metadata.id+"/"+metadata.link}><i className=" bx bx-link-external font-size-20"></i></Link></div> */}
      </div>
      </CardBody>
    </Card>
  );
};

CustomCard.propTypes = {
  onClick: PropTypes.func,
  title: PropTypes.string.isRequired,
  description: PropTypes.string,
  metadata: PropTypes.shape({
    mobile: PropTypes.string,
    email: PropTypes.string,
    id:PropTypes.number,
    link:PropTypes.string
  }),

};
// Custom Lane component

const LaneHeader = styled.div`
  background-color: ${props => props.color} !important;
  color: white !important;
  padding: 10px !important;
  border-top-left-radius: 8px !important;
  border-top-right-radius: 8px !important;
  font-weight: bold !important;
`;
const LaneBody = styled.div`
  background-color: #f8f9fa;
  padding: 10px;
  border-bottom-left-radius: 8px;
  border-bottom-right-radius: 8px;
`;
const getLaneColor = (index) => {
  const colors = ['#007bff', '#28a745', '#ffc107', '#dc3545', '#17a2b8', '#6610f2'];
  return colors[index % colors.length];
};

const CustomLane = ({ index, title, children }) => {
  const color = getLaneColor(index);
  return (
    <div>
      <LaneHeader color={color}>{title}</LaneHeader>
      <LaneBody>{children}</LaneBody>
    </div>
  );
};

// const CustomLanes = ({ index, title, children }) => {
//   const color = getLaneColor(index);
//   return (
//     <div style={{ backgroundColor: '#f8f9fa' }}>
//       <div style={{ backgroundColor: color }}>
//         {title}
//       </div>
//       {children}
//     </div>
//   );
// };
CustomLane.propTypes = {
  index: PropTypes.number.isRequired,
  title: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired
};

class ClassificationContact extends Component {
  constructor(props) {
    super(props)
    this.state = {
      contacts: [],
    }
    this.toggleAddNew = this.toggleAddNew.bind(this);
  }
  toggleAddNew() {
    this.setState({ isAddNew: !this.state.isAddNew });

  }

  componentDidMount() {
    const { onGetAllContact } = this.props;
    onGetAllContact(localStorage.getItem('userId'));
  }

 
onCardMoveAcrossLanes = (fromLaneId, toLaneId, cardId, index) => {
    const pastData = {
      id: cardId,
      oldContactClassificationId: fromLaneId,
      newContactClassificationId: toLaneId,
      agentId: parseInt(localStorage.getItem('userId'))
    };
    this.props.updateClassificationBoard(pastData, this.props.history);
   
  };
  render() {
    const { contacts, gridLoading, isResponsive } = this.props;
    
    const contactClassificationList = [
      { id: 0, name: 'Unassigned' },
      { id: 1, name: 'Silver' },
      { id: 2, name: 'Gold' },
      { id: 3, name: 'VIP' },
      { id: 4, name: 'Investor' },
      { id: 5, name: 'Vendors' }
    ];
 
    const data = {
      
      lanes: contactClassificationList.map(stage => ({
        id: stage.id,
        title: stage.name,
        cards: contacts
          .filter(contact => contact.contactClassificationId === stage.id)
          .map(contact => ({
            id: contact.id,
            title: `${contact.firstName} ${contact.lastName}`,
           
            draggable: true,
            label: '',
            metadata: { 
              mobile: contact.mobile,
              email: contact.email,
             
              id:contact.id,
              link: contact.contactId,
            }
          }))
      }))
    };


const renderMobileAccordion = () => {
       
      return (
        <Card>
          <CardBody>
             <Accordion
          open={this.state.openLane}
          toggle={(id) =>
            this.setState({ openLane: this.state.openLane === id ? null : id })
          }
        >
          {data.lanes.map((lane) => (
            <AccordionItem key={lane.id}>
              <AccordionHeader targetId={lane.id}>{lane.title}</AccordionHeader>
              <AccordionBody accordionId={lane.id}>
                {lane.cards.map((card) => (
                  <CustomCard
                    key={card.id}
                    {...card}
                   
                  />
                ))}
              </AccordionBody>
            </AccordionItem>
          ))}
        </Accordion>
          </CardBody>
        </Card>
       
      );
    };
   //
    return (
      <React.Fragment>
        <ToastContainer autoClose={2000} />
        {gridLoading ? (
          <div className="rs-loader-overlay">
            <div className="rs-loader"></div>
          </div>
        ) : null}
        <div className="page-content project-page-content">
          <MetaTags>
            <title>Classification View | Realty Space</title>
          </MetaTags>
          <Container fluid className="ps-0">
            {/* Render Breadcrumbs */}
            {/* <Row className="project-header">
              <Col sm="7">
                <Breadcrumbs title="Contacts" breadcrumbItem="Classification View" />
              </Col>
              <Col sm="5">
                <div className="pt-2 float-end mt-2">
                  <RsAdNew to="/contact/import-contact" className="btn btn-light btn-md me-2" iconClass="bx bx-download">Import Contact</RsAdNew>
                  <RsAdNew to="#" onClick={this.toggleAddNew} className="btn btn-light btn-md" iconClass="bx bx-plus-medical">Add New</RsAdNew>
                </div>
              </Col>
            </Row> */}
             <Card className="card-without-border">
              <CardHeader className="">
            <FilterMenuContact />
            </CardHeader>
            </Card>
            {!isResponsive &&(
             <Row style={{paddingLeft:20}}>
                  <Col sm="12">
                    
                      <img src={dragImg} width="32px" /> 
                      Drag & Drop Available 
                  </Col>
                </Row>
            )}
            <Row>
              <Col lg="12">
                <Card >

                </Card>
                {isResponsive ? renderMobileAccordion() :(

                   <StyledBoard 
                              style={{backgroundColor: 'white'}}
                              data={data} 
                              onCardMoveAcrossLanes={this.onCardMoveAcrossLanes}
                              draggable
                              laneDraggable={false}
                              cardDraggable
                              components={{ 
                                Card: props => <CustomCard {...props} />,
                                Lane: CustomLane
                              }}
                            />
                )
                    
                }
              
               
                {/* <Board initialBoard={board} onCardDragEnd={this.handleCardDragEnd}
                /> */}

              </Col>
            </Row>

          </Container>
        </div>
        <Offcanvas
          isOpen={this.state.isAddNew}
          direction="end"
          toggle={this.toggleAddNew}
          style={{ width: 800 }}
        >
          <OffcanvasHeader toggle={this.toggleAddNew}>
            New Contact
          </OffcanvasHeader>
          <OffcanvasBody>
            <CreateContact toggleAddNew={this.toggleAddNew} />
          </OffcanvasBody>
        </Offcanvas>
      </React.Fragment>
    )
  }
}

ClassificationContact.propTypes = {
  t: PropTypes.any,
  history:PropTypes.object,
  onGetAllContact: PropTypes.func,
  contacts: PropTypes.array,
  gridLoading: PropTypes.object,
  updateClassificationBoard:PropTypes.func,
  isResponsive:PropTypes.object

}
const mapStateToProps = ({ contact }) => (
  {
    gridLoading: contact.gridLoading,
    contacts: contact.contacts,
  })
const mapDispatchToProps = dispatch => ({
  onGetAllContact: (agentId) => dispatch(getContacts(agentId)),
  updateClassificationBoard:(data) => dispatch(updateClassificationBoard(data))
});
export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(ClassificationContact))

